import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const useYearStats = (year: number) => {
  return useQuery({
    queryKey: ['useYearStats', year],
    queryFn: () =>
      year &&
      axios
        .get(`${envApiUrl}/years/stats`, {
          headers: {
            'Content-Type': 'application/json',
            year,
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => response.data),
  });
};
